import { useQuery } from "@tanstack/react-query";
import ApiClient from "../../../api/ApiClient";
import { UserAssignment } from "../interfaces/UserAssignment";

async function get({ userId }: { userId: string }): Promise<UserAssignment[]> {
    const response = await ApiClient({
        url: `/user-assignments/users/${userId}`,
        method: "GET",
    });
    if (response.status === 200) {
        return response.data ?? [];
    }
    throw new Error(response.data?.message || "Failed to delete user assignments.");
}

export function useGetUserAssignmentQuery(data: { userId: string }, enabled: boolean = false) {
    return useQuery<UserAssignment[]>({
        queryKey: ["get-user-assignment"],
        queryFn: () => get(data),
        refetchOnWindowFocus: false,
        enabled: enabled
    });
}